import { render, staticRenderFns } from "./DealsReportsNeopag.vue?vue&type=template&id=5d6af976&"
import script from "./DealsReportsNeopag.vue?vue&type=script&lang=js&"
export * from "./DealsReportsNeopag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports